import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider } from '@/components/SidebarNew/ui/sidebar';
import { AppSidebar } from '@/components/SidebarNew/AppSidebar';
import { DashboardHeader } from '@/components/Header/DashboardHeader';
import styles from './DashboardLayout.module.scss';

interface DashboardLayoutProps {
  userRole?: 'user' | 'super_admin';
  user?: {
    email: string;
    displayName?: string;
    photoURL?: string;
  };
  children?: React.ReactNode;
}

export function DashboardLayout({
  userRole = 'user',
  user = {
    email: 'tuanminh@gmail.com',
    displayName: 'Tuan Minh',
  }
}: DashboardLayoutProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    // console.log('Logging out...');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleSettingsClick = () => {
    navigate('/settings/billing');
  };

  return (
    <SidebarProvider defaultOpen={true}>
      <div className={styles.dashboardLayout}>
        {/* Sidebar */}
        <AppSidebar userRole={userRole} />

        {/* Header Area */}
        <div className={styles.mainContent}>
          <DashboardHeader
            user={user}
            onLogout={handleLogout}
            onProfileClick={handleProfileClick}
            onSettingsClick={handleSettingsClick}
          />

          {/* Page Content */}
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
